import React from "react";
export const ShowError = ({message} : any): JSX.Element => {
  return message !== '' ? <div className="invalid-feedback display: show; ">
    {message+''}
  </div>: <div></div>
}
